@if (toolbar$ | async; as toolbar) {
  <ng-template
    *ngComponentOutlet="
      toolbar.component;
      inputs: toolbar.inputs;
      injector: toolbar.injector
    "
  />
}
